import { render, staticRenderFns } from "./ChangeDataHistory.vue?vue&type=template&id=fdbca704&scoped=true&"
import script from "./ChangeDataHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeDataHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDataHistory.vue?vue&type=style&index=0&id=fdbca704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbca704",
  null
  
)

export default component.exports